import texts from '../texts.json';
import { reportError } from './reportError';

/**
 * The wire contract from `leadCampaign-sendLeadCampaign`. A manual send is built in the request
 * when it can be, and left for the hourly scheduler when Brevo is rate limiting or out of list
 * headroom.
 */
export const SEND_OUTCOME = { SCHEDULED: 'SCHEDULED', QUEUED: 'QUEUED' };

/**
 * Picks the toast for how the send actually went.
 *
 * An unrecognised value means the server and this repo have drifted — they deploy independently, so
 * web shipping first sees no `outcome` at all. That reports rather than falling through silently,
 * but still falls back to the queued copy: it promises less than may have happened, which is the
 * safer way to be wrong.
 */
export const sendToast = (outcome) => {
  if (outcome === SEND_OUTCOME.SCHEDULED) return texts.sendStatus.sendingSoon;
  if (outcome !== SEND_OUTCOME.QUEUED) {
    reportError('sendCampaign.unknownOutcome', new Error(`Unrecognised send outcome: ${String(outcome)}`));
  }
  return texts.sendStatus.queued;
};
